// src/admin/screens/kyc/PhotoPanel.tsx
// Three-tile grid for NRC front, NRC back, and selfie. Clicking a tile
// opens the shared Lightbox at the same signed URL. The SignedImage
// component resolves the URL via getSignedDocUrl(), which records a
// `kyc.view_media` audit row — so the reviewer's photo access is logged
// without any extra wiring here.
//
// All three photos live in the `kyc` bucket (single-word — not
// `kyc-documents` as the original plan assumed).
import { useState } from 'react';
import SignedImage from '@admin/components/SignedImage';
import Lightbox from '@admin/components/Lightbox';
import Card from '@admin/components/Card';

interface Props {
  submissionId: string;
  front: string | null;
  back: string | null;
  selfie: string | null;
}

export default function PhotoPanel({ submissionId, front, back, selfie }: Props) {
  const [zoomUrl, setZoomUrl] = useState<string | null>(null);

  const tiles: { label: string; path: string | null }[] = [
    { label: 'NRC front', path: front },
    { label: 'NRC back', path: back },
    { label: 'Selfie', path: selfie },
  ];

  return (
    <>
      <Card title="Documents">
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 12,
          }}
        >
          {tiles.map((t) => (
            <div key={t.label}>
              <p className="small" style={{ marginBottom: 4, color: 'var(--c-text-muted)' }}>
                {t.label}
              </p>
              {t.path ? (
                <SignedImage
                  bucket="kyc"
                  path={t.path}
                  target_type="kyc"
                  target_id={submissionId}
                  alt={t.label}
                  onClick={(url) => setZoomUrl(url)}
                  className="kycThumb"
                />
              ) : (
                <div
                  style={{
                    width: '100%',
                    height: 160,
                    borderRadius: 8,
                    border: '1px dashed var(--c-border)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--c-text-muted)',
                    fontSize: 13,
                  }}
                >
                  Not submitted
                </div>
              )}
            </div>
          ))}
        </div>
      </Card>
      <Lightbox url={zoomUrl} onClose={() => setZoomUrl(null)} />
    </>
  );
}
